// A level can load automatically (the first-run tutorial). Only report play
// after input, and cancel a pending start if that level ends before any input.
export class GameplaySession {
    constructor(getSDK = () => PokiSDK) {
        this.getSDK = getSDK;
        this.interacted = false;
        this.playing = false;
        this.active = false;
    }

    listen(document) {
        const interact = event => {
            if (event.isTrusted) this.interact();
        };
        document.addEventListener('pointerdown', interact, {capture: true});
        document.addEventListener('keydown', interact, {capture: true});
    }

    interact() {
        this.interacted = true;
        if (this.playing) this.start();
    }

    start() {
        this.playing = true;
        if (!this.interacted || this.active) return;
        this.active = true;
        this.getSDK().gameplayStart();
    }

    stop() {
        this.playing = false;
        if (!this.active) return;
        this.active = false;
        this.getSDK().gameplayStop();
    }
}
